<template>
  <!-- -->
  <div class="image-data-setting mini-component">
    <div class="desc">
      允许上传一张图片，图片可以绑定跳转功能，也可以不绑定，如果不绑定跳转功能，则图片不能打开链接，只能用作页面装饰使用
    </div>
    <alone-data v-model="settingData" @change="changeData" :show-icon="false" :show-tag="false" :show-background="false"/>
  </div>
</template>

<script>

import AloneData from "@/views/h5/common/sys/miniProgram/setting/component/AloneData.vue";
export default {
  emits: ["change"],
  props: {
    data: {
      type: Object,
      default: () => {
        return {componentData: {}}
      }
    }
  },
  name: "",
  components: {
    AloneData
  },
  data() {
    return {
      settingData: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      if (!this.data.componentData) {
        this.settingData = {size: ""};
      } else {
        this.settingData = this.data.componentData;
      }
    },
    changeData() {
      this.$emit("change", {...this.data, componentData: this.settingData});
    }
  }
};
</script>

<style lang="scss" scoped>
.image-data-setting{

}
</style>